import { defaultConfig } from '../config';
import { apiService } from './apiService';

// URL identity always comes from the backend, never a frontend shop registry.
export async function resolveProperty(entry) {
  const query = entry.query;
  const widget = query.get('from_widget') === 'true';
  const pathCode = entry.shopCode || entry.slug;
  let config;
  if (pathCode) {
    config = await apiService.resolveShopCode(pathCode);
  } else {
    // Cleaned widget links retain explicit identity so refresh/checkout can
    // recover the widget shop without making a plain root visit session-driven.
    const requestedCode = query.get('shop_code');
    const requestedId = query.get('shop_id');
    if (requestedCode) {
      // Complete legacy widget pairs keep their existing API flow. Code-only
      // widget entries can use the same dynamic bootstrap as property URLs.
      config = requestedId ? {
        ...defaultConfig, shop_id: requestedId, shop_code: requestedCode,
      } : await apiService.resolveShopCode(requestedCode);
    } else {
      // A bare URL always means the deployment's default shop. Session data may
      // restore a matching booking later, but cannot choose another shop here.
      config = { ...defaultConfig };
      if (requestedId) config.shop_id = requestedId;
      if (config.shop_code && !config.shop_id) config = await apiService.resolveShopCode(config.shop_code);
    }
  }
  if (!config.shop_id || !config.shop_code) throw new Error('The default shop is not configured.');
  if (pathCode && widget &&
      ((query.get('shop_id') && query.get('shop_id') !== String(config.shop_id)) ||
       (query.get('shop_code') && query.get('shop_code').toLowerCase() !== config.shop_code.toLowerCase()))) {
    throw new Error('The widget property does not match this URL. Open the original widget link.');
  }
  const hotels = await apiService.getHotelList('', { config, strict: true });
  const id = query.get('hotel_id');
  const hotel = id ? hotels.find(item => String(item.id) === String(id)) : hotels[0] || null;
  if (id && !hotel) throw new Error('The selected hotel is not available in this shop.');
  return { config, hotels, hotel, legacy: !pathCode, kind: 'shop' };
}
